/**
 * @file Atom: PhoneFrameBorder
 * @description Reusable decorative outer frame border that wraps game screens.
 * Provides a phone-like frame with responsive width that expands on larger mobile screens.
 */

import type React from 'react';

interface PhoneFrameBorderProps {
  /** Optional additional CSS classes */
  className?: string;
}

const PhoneFrameBorder: React.FC<PhoneFrameBorderProps> = ({
  className = '',
}) => {
  return (
    <div
      className={`absolute bg-transparent h-[calc(100%-20px)] left-1/2 pointer-events-none rounded-[2px] top-[10px] translate-x-[-50%] w-[calc(100%-20px)] ${className}`}
    >
      {/* Outer border with glow */}
      <div className="absolute border-[0.5px] border-solid border-white inset-0 rounded-[2px] shadow-[0px_0px_10px_0px_rgba(255,255,255,0.3)]" />
      {/* Inner glow */}
      <div className="absolute inset-0 shadow-[0px_0px_10px_0px_inset_rgba(255,255,255,0.3)]" />
    </div>
  );
};

export default PhoneFrameBorder;
